import React from 'react'
import PropTypes from 'prop-types'
import intl from 'react-intl-universal'
import { Breadcrumb as BreadcrumbStrap } from 'reactstrap' // todo: remove Breadcrumb components on components/qstrap folder
import { Container, SVGIcon, BreadcrumbItem } from 'components/qstrap'

const Breadcrumb = ({ paths }) => (
  <Container className="Breadcrumb p-x-0">
    <BreadcrumbStrap className="BreadcrumbContainer" itemScope itemType="http://schema.org/BreadcrumbList" >
      <div className="list-wrapper">
        <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem">
          <BreadcrumbItem itemProp="item" tag="a" href="https://campus.quipper.com/">
            <span itemProp="name">
              <p hidden>Quipper Campus</p>
              <SVGIcon name="nav-home" size="sm" alt="Quipper Campus"/>
            </span>
          </BreadcrumbItem>
          <meta itemProp="position" content="1"/>
        </li>
        {
          paths.map((path, num) => {
            if (path.url === '#') {
              return (
                <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem" key={`brc-${num}`}>
                  <BreadcrumbItem itemProp="item" href={path.url} tag="b">
                    <span itemProp="name">
                      {intl.get(`breadcrumb.${path.name}`) || path.name}
                    </span>
                  </BreadcrumbItem>
                  <meta itemProp="position" content={`${num + 2}`}/>
                </li>
              )
            }
            return (
              <li itemProp="itemListElement" itemScope itemType="http://schema.org/ListItem" key={`brc-${num}`}>
                <BreadcrumbItem itemProp="item" href={`https://campus.quipper.com${path.url}`} tag="a">
                  <span itemProp="name">
                    {intl.get(`breadcrumb.${path.name}`) || path.name}
                  </span>
                </BreadcrumbItem>
                <meta itemProp="position" content={`${num + 2}`}/>
              </li>
            )
          })
        }
      </div>
    </BreadcrumbStrap>
    <style jsx global>
      {`
        .breadcrumb {
          margin: 0 !important;
        }
      `}
    </style>
  </Container>
)

Breadcrumb.propTypes = {
  paths: PropTypes.arrayOf(PropTypes.object),
}

Breadcrumb.defaultProps = {
  paths: [],
}

export default Breadcrumb
